<template>
    <div class="store-map" :class="{ 'no-head': noHead }">
        <header class="addr-query">
            <form @submit.prevent="updateSotreByAddr">
                <div class="addr-sel" @click.stop="pickLocation">
                    <label class="lbl-sel">{{ selectedCountry.name || selectedCity.name || '请选择' }}</label>
                    <i class="icon-caret"></i>
                </div>
                <div class="addr-input">
                    <i class="icon-search" :class="{ close: inputAddr !== '' }" @click="resetQueryAddr"></i>
                    <i v-show="inputAddr !== ''" class="icon-close" @click="resetQueryAddr"></i>
                    <input
                        v-model="inputAddr"
                        type="search"
                        placeholder="输入服务点名称或地址"
                        @keyup.up="goPrev"
                        @keyup.down="goNext"
                        @input="queryAddrList"
                    />
                </div>
            </form>
        </header>
        <section class="tabs">
            <div class="tab" :class="{ active: curType == '1,2,4,5' }" @click="changeTab('1,2,4,5')">全部</div>
            <div class="tab" :class="{ active: curType == '5' }" @click="changeTab('5')">丰巢柜</div>
            <div class="tab" :class="{ active: curType == '1,4' }" @click="changeTab('1,4')">顺丰网点</div>
            <div class="tab" :class="{ active: curType == '2' }" @click="changeTab('2')">合作商家店</div>
        </section>
        <!-- 查询结果状态，互斥关系 -->
        <section class="result">
            <div v-show="lstAddr.length > 0" class="query-list">
                <load-more :list="lstAddr">
                    <ul ref="refAddrs" class="lst-result">
                        <li
                            v-for="(item, index) in lstAddr"
                            :key="index"
                            :class="{ active: selectedAddrIdx === index }"
                            @click="updateSotreByAddr({ index })"
                        >
                            <span class="txt-name">{{ item.name }}</span>
                            {{ item.detail_addr }}
                        </li>
                    </ul>
                </load-more>
            </div>
            <store-list v-show="showResult(resultStatus.store) && storeList.length > 0" :lstStore="storeList" @navigate="gotoNavigation"></store-list>
            <!-- <div v-show="showResult(resultStatus.noLocation)" class="err-info">{{ tips.noLocation }}</div> -->
            <div v-show="showResult(resultStatus.noStore)" class="err-info">
                {{ tips.noStore }}
            </div>
            <!-- <div v-show="storeList.length < 1" class="err-info">{{ tips.noStore }}</div> -->
        </section>
        <overlay :isShow.sync="isShowSelector" :finished.sync="selectCompleted" :enableBtn.sync="enableBtn">
            <city-selector
                :areaData="areaData"
                :selectCompleted.sync="enableBtn"
                :selectedProvince.sync="selectedProvince"
                :selectedCity.sync="selectedCity"
                :selectedCountry.sync="selectedCountry"
                :selectedAreaType.sync="selectedAreaType"
            />
            <slot slot="button" slot-scope="props">
                <div class="btn-confirm" :class="{ active: props.active }">
                    <span>确认</span>
                </div>
            </slot>
        </overlay>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import ajax from '@/api/ajax'
import Overlay from '@/components/citySelector/overlay/'
import CitySelector from '@/components/citySelector'
import MixCitySelector from '@/components/citySelector/mixin'
import LoadMore from './components/load-more'
import StoreList from './components/storeList'
import { getDistance, getLocByAddr, convertFrom } from './amap'
import { Indicator } from 'mint-ui'
import _ from 'lodash'
import UIP from '@/util/uip.js'

export default {
    name: 'StoreQuery',
    components: {
        overlay: Overlay,
        'city-selector': CitySelector,
        'load-more': LoadMore,
        'store-list': StoreList
    },

    mixins: [MixCitySelector],
    data() {
        return {
            isShowSelector: false, // 是否显示城市选择框
            selectCompleted: false, // 选择是否完成
            enableBtn: false, // 选择结束，激活按钮
            resultStatus: {
                // 结果展示区域的类型
                address: 'address',
                store: 'store',
                tip: 'tip',
                noLoaction: 'noLocation',
                noStore: 'noStore'
            },
            curResultStatu: '', // 当前结果状态
            inputAddr: '', // 用户查询输入的地址
            selectedAddrIdx: 0, // 选中地址列表项的索引
            lstAddr: [
                // 详细地址的信息列表
                /**
                 * { province, city, distinct, detail_addr, name, regcode, key_prefix }
                 */
            ],
            storeList: [
                // 网点列表
                /**
                 * {
                 *      接口提供：name, nameEN, address, code, deptCode, lat, lng,
                 *       linkman, serviceContent, serviceTime, storeType
                 *      自定义：
                 *      网点到定位的距离, distinct
                 * }
                 */
            ],
            map: null, // 地图查询接口
            tips: {
                // 查询失败的提示信息
                noLocation: '定位失败，请选择城市',
                noStore: '没有相关服务点哦'
            },
            curType: '1,2,4,5',
            curLat: '',
            curLng: ''
        }
    },
    computed: {
        ...mapGetters('storeMap', ['locationInfo', 'storeInfo', 'locLngLat', 'storeLngLat']),
        showResult() {
            return function (statu) {
                return this.curResultStatu === statu
            }
        },
        noHead() {
            return Boolean(this.$route.query.noHead === 'true')
        }
    },
    watch: {
        selectCompleted(val) {
            if (!val) {
                return
            }
            this.inputAddr = '' // 根据选择的城市区域名称
            const province = this.selectedProvince.name || ''
            const city = this.selectedCity.name || ''
            const country = this.selectedCountry.name || ''
            const address = `${province}${city}${country}`
            if (!this.inputAddr) {
                return this.$toast(this._ll('请输入服务点名称或地址'))
            }
            getLocByAddr({ address })
                .then(({ lng, lat }) => {
                    if (lat && lng) {
                        this.curLat = lat
                        this.curLng = lng
                        this.getNearbyStore({ lat, lng })
                            .then(success => {
                                // 根据城市名称查经纬度，更新网点信息
                                if (!success) {
                                    return
                                }
                                this.$store.commit('storeMap/setStoreInfo', {
                                    // 更新网点信息
                                    lng,
                                    lat,
                                    province,
                                    city,
                                    country
                                })
                            })
                            .catch(e => {
                                this.curResultStatu = this.resultStatus.noStore
                            })
                    }
                })
                .catch(err => {
                    this.curResultStatu = this.resultStatus.noStore
                })
        }
    },
    beforeCreate() {
        this.$store.commit('setTitle', this._ll('网点查询'))
    },
    async created() {
        this.queryAddrList = _.debounce(this.getAddrList, 800)
        this.setShowHeader(!this.noHead)
    },
    mounted() {
        this.init()
        this.curResultStatu = this.resultStatus.store
    },
    methods: {
        ...mapMutations({
            setTitle: 'setTitle',
            setShowHeader: 'setShowHeader'
        }),
        ...mapMutations('storeMap', ['setLocation', 'setStoreInfo']),
        async init() {
            Indicator.open('定位中')
            try {
                const {
                    data: { longitude, latitude }
                } = await this.$I.geo.location.getCurrentPosition({
                    // UIP获取定位经纬度
                    h5: true,
                    bdmap: true,
                    gdmap: false
                })
                const { province, city, district } = await UIP.interface.geo.gis.RGEO({
                    // 获取定位的城市相关信息
                    x: longitude,
                    y: latitude,
                    poinum: 1
                })
                const { lng, lat } = await convertFrom({
                    // 转化为高德地图的经纬度
                    lng: longitude,
                    lat: latitude,
                    type: 'baidu'
                })
                if (lng && lat) {
                    const areaData = {
                        province,
                        city,
                        country: district
                    }
                    this.curLat = lat
                    this.curLng = lng
                    this.$store.commit('storeMap/setLocation', { ...areaData, lng, lat }) // 同步定位信息
                    this.initCitySelector(areaData) // 根据定位加载城市信息
                    this.getNearbyStore({ lng, lat }) // 根据定位加载附近网点列表
                } else {
                    this.$toast(this._ll('定位失败，请手动选择地址'))
                    this.initCitySelector({}) // 根据定位加载城市信息
                }
                Indicator.close()
            } catch (e) {
                this.$toast(this._ll('定位失败，请手动选择地址'))
                console.log(e)
                Indicator.close()
            }
        },
        changeTab(type = '') {
            if (this.curType === type) {
                return
            }
            this.curResultStatu = this.resultStatus.store
            this.curType = type
            this.getNearbyStore()
        },
        pickLocation() {
            this.isShowSelector = true
            this.curResultStatu = this.resultStatus.store
        },
        async getNearbyStore({ lat = this.curLat, lng = this.curLng } = {}) {
            let hasResult = false
            let data = []
            Indicator.open()
            try {
                const res = await ajax.getNearbyStore({
                    params: {
                        latitude: lat,
                        longitude: lng,
                        range: 3000,
                        storeType: this.curType
                    }
                })
                data = res.data
            } catch (e) {
                this.curResultStatu = this.resultStatus.noStore
            }
            if ((data || []).length > 0) {
                const distincts = await getDistance({
                    // 根据定位信息和网点位置的经纬度，计算距离
                    lstLngLat: data,
                    location: {
                        lat: this.curLat,
                        lng: this.curLng
                    }
                })
                distincts &&
                    distincts.forEach((item, index) => {
                        data[index] && (data[index].distinct = item)
                    })
                data.sort((a, b) => a.distinct - b.distinct) // 更新网点列表及距离信息
                this.storeList = data
                hasResult = true
            } else {
                this.curResultStatu = this.resultStatus.noStore
                this.storeList = []
            }
            Indicator.close()
            return hasResult
        },
        async getAddrList() {
            const noPass = !this.validInputAddr()
            // debugger
            if (noPass) {
                if (this.inputAddr === '') {
                    // 没有地址搜索结果
                    this.curResultStatu = this.resultStatus.store // 同步弹窗状态,没有输入,则显示网点列表
                } else {
                    // this.curResultStatu = this.resultStatus.noStore // 同步弹窗状态，有输入，则显示无网点
                    // this.$toast(this._ll('无法查询此地址，请修改重试'))
                }
                return
            }
            let datalist = []
            try {
                const res = await ajax.getDetailAddList({
                    params: {
                        ak: '14e9ee810854c40f5ae9414f2a62c8cc',
                        q: this.inputAddr,
                        city: this.selectedCity.name,
                        district: this.selectedCountry.name
                    }
                })
                const data = res.data.result.POISet
                const hasResult = data && Array.isArray(data) && data.length > 0
                if (!hasResult) {
                    // this.curResultStatu = this.resultStatus.noStore // 同步弹窗状态，显示无网点
                    this.$toast(this._ll('无法查询此地址，请修改重试'))
                    this.lstAddr = []
                    return
                }
                datalist = data.map(item => {
                    const [province, city, distinct] = item.adname
                    return {
                        detail_addr: item.detail_addr,
                        key_prefix: item.key_prefix,
                        regcode: item.regcode,
                        name: item.name,
                        province,
                        city,
                        distinct,
                        lng: item.xcoord,
                        lat: item.ycoord
                    }
                })
            } catch (e) {
                this.$toast(this._ll('无法查询此地址，请修改重试'))
                // this.curResultStatu = this.resultStatus.noStore // 同步弹窗状态，显示无网点
            }
            this.lstAddr = this.lstAddr.splice(0) && datalist
            this.selectedAddrIdx = 0 // 更新选中地址索引
        },
        goPrev() {
            this.selectedAddrIdx = Math.max(this.selectedAddrIdx - 1, 0)
        },
        goNext() {
            if (Array.isArray(this.lstAddr)) {
                this.selectedAddrIdx = Math.min(this.selectedAddrIdx + 1, this.lstAddr.length - 1)
            }
        },
        validInputAddr() {
            let valid = !!this.inputAddr // 验证输入空
            const reg = new RegExp("[`~!@#$%^&*()+=|{}':;',\\[\\].<>/?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、？]") // 是否有特殊字符
            const noPass = reg.test(this.inputAddr)
            noPass && (valid = false)
            return valid
        },
        resetQueryAddr() {
            this.inputAddr = ''
            this.lstAddr = []
            // this.curResultStatu = this.resultStatus.store // 同步显示弹窗状态
        },
        async updateSotreByAddr({ index }) {
            // 提交查询地址，更新网点信息
            if (index > -1) {
                const storeName = (this.lstAddr[index] || {}).name
                this.inputAddr = storeName
            }
            if (this.lstAddr.length <= 0) {
                return
            }
            this.selectedAddrIdx = index
            this.curResultStatu = this.resultStatus.store // 更新至网点查询状态
            try {
                const { lng, lat } = this.lstAddr[index]
                if (lat && lng) {
                    this.curLat = lat
                    this.curLng = lng
                    this.getNearbyStore({ lat, lng })
                        .then(hasResult => {
                            // 根经纬度, 获取网点信息
                            if (hasResult) {
                                this.$store.commit('storeMap/setStoreInfo', { lng, lat }) // 更新网点信息
                                const { province, city, distinct } = this.lstAddr[this.selectedAddrIdx] || {}
                                if (province && city && distinct) {
                                    this.initCitySelector({
                                        province,
                                        city,
                                        country: distinct
                                    })
                                }
                            } else {
                                this.curResultStatu = this.resultStatus.noStore
                            }
                        })
                        .catch(err => {
                            this.curResultStatu = this.resultStatus.noStore
                        })
                    this.lstAddr = []
                }
            } catch (e) {
                console.log(e, '根据地址获取经纬度失败')
            }
        },
        gotoNavigation(index) {
            const selectedStore = this.storeList[index]
            selectedStore && this.$store.commit('storeMap/setStoreInfo', selectedStore) // 提交选中网点的信息
            this.$router.push({
                path: `nav?noHead=${this.noHead}`
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.store-map {
    font-family: PingFangSC-Medium;
    $hh: 0.7rem; // 搜索栏的高度
    max-width: 7.5rem;
    height: 100%;
    margin: 0 auto;
    &.no-head {
        padding-top: 0;
    }
    .tabs {
        display: flex;
        justify-content: space-between;
        padding: 0.22rem 0.4rem;
        .tab {
            font-size: 0.32rem;
            color: #808080;
            position: relative;
            font-weight: 500;
            &.active {
                color: #0f1214;
                &::after {
                    content: ' ';
                    height: 0.08rem;
                    width: 100%;
                    display: inline-block;
                    background: #fe583c;
                    bottom: -0.14rem;
                    position: absolute;
                    border-radius: 0.34rem;
                    left: 0;
                }
            }
        }
    }
    .addr-query {
        width: 100%;
        max-width: 7.5rem;
        padding: 0 0.4rem;
        margin-top: 0.1rem;
        background: linear-gradient(#fff 70%, rgba(255, 255, 255, 0.1) 100%, transparent);
        form {
            height: $hh;
            line-height: $hh;
            border-radius: 0.5rem;
            background: #f7f7f7;
            display: flex;
            .addr-sel {
                text-indent: 0.2rem;
                position: relative;
                padding-right: 0.5rem;
                .lbl-sel {
                    display: inline-block;
                    /* width: 9ch; */
                    font-weight: 400;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    font-size: 0.3rem;
                    font-size: 0.28rem;
                    color: #0f1214;
                    max-width: 9ch;
                }
                .icon-caret {
                    &::after {
                        content: ' ';
                        width: 0;
                        height: 0;
                        border: 0.09rem solid transparent;
                        border-top: 0.09rem solid #333;
                        position: absolute;
                        top: 0.33rem;
                        margin-left: 0.1rem;
                    }
                }
            }
            .addr-input {
                flex: 1;
                display: inline-block;
                border-left: solid 1px #ccc;
                position: relative;
                margin: 0.15rem 0;
                input {
                    background: transparent;
                    border: none;
                    height: 0.7rem;
                    padding: 0;
                    width: 100%;
                    padding-right: 0.7rem;
                    font-size: 0.28rem;
                    position: relative;
                    top: -0.15rem;
                    padding-left: 0.76rem;
                }
                .icon-search {
                    z-index: 2;
                    position: absolute;
                    top: -0.05rem;
                    left: 0.16rem;
                    width: 0.5rem;
                    height: 0.5rem;
                    background: url('~@/assets/images/ico/icon-search.png') center / cover;
                }
                .icon-close {
                    z-index: 2;
                    position: absolute;
                    top: -0.05rem;
                    right: 0.16rem;
                    width: 0.5rem;
                    height: 0.5rem;
                    background: url('~@/assets/images/ico/icon-close-popup.svg') center / cover;
                }
            }
            &:focus-within {
                box-shadow: 0px 5px 13px 3px rgba(0, 0, 0, 0.1);
            }
        }
    }
    .result {
        height: 100%;
        .query-list {
            background: #fff;
            border-radius: 0 0.1rem 0.1rem 0;
            box-shadow: 3px 5px 13px 3px rgba(200, 200, 200, 0.3);
            height: 100%;
            overflow-y: scroll;
            overflow-x: hidden;
            .lst-result {
                ul {
                    font-size: 12px;
                    line-height: 2;
                }
                li {
                    padding: 0.23rem 0.6rem;
                    &.active {
                        background: #f9f9f9;
                    }
                    .txt-name {
                        display: inline-block;
                        white-space: nowrap;
                        min-width: 2rem;
                        margin-right: 0.2rem;
                        font-weight: bolder;
                    }
                }
            }
        }
    }
    .err-info {
        height: 5rem;
        line-height: 5rem;
        text-align: center;
        border-radius: 0.1rem;
        margin: 0 0.05rem;
        box-shadow: 3px 3px 13px 5px rgba(200, 200, 200, 0.1);
    }
    .btn-confirm {
        padding: 0.2rem.5rem;
        >>> span {
            display: inline-block;
            width: 100%;
            border-radius: 0.48rem;
            text-align: center;
            color: #fff;
            font: bold 0.34rem/3 YaHei;
            letter-spacing: 0.5rem;
            text-indent: 0.5rem;
            background: rgba(0, 0, 0, 0.3);
        }
        &.active {
            >>> span {
                background: #dc1e32;
                color: #ffffff;
            }
        }
    }
    ::-webkit-scrollbar {
        display: none;
    }
    -webkit-overflow-scrolling: touch;
    input[type='search']::-webkit-search-cancel-button {
        display: none;
        -webkit-appearance: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/store/query.vue